<template>
    <div class="card-product-box" v-show="null != materialList && materialList.length > 0" ref="threeShopMaterialBox">
        <div class="title-part">
<!--            <span class="title-span">{{titleText}}</span>-->
            <div v-show="materialList.length > 4"><span><font-awesome-icon @click="previousMaterial" icon="fa-solid fa-chevron-left" /></span><span style="margin-left: 1em;"><font-awesome-icon @click="nextMaterial" icon="fa-solid fa-chevron-right" /></span></div>
        </div>

        <div class="material-part">
            <div class="material-inline-block" :style="{left: `${(index - changeNum) * 25}%`}" v-for="(value, index) in materialList" :key="value.id">
                <threeShopMaterial @clickAskBtn="throwAskEvent" :obj="value"/>
            </div>
        </div>

    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, onUnmounted, ref, computed} from "vue";
    import threeShopMaterial from '@/components/threeShopMaterial.vue'
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faChevronRight, faChevronLeft} from '@fortawesome/free-solid-svg-icons'

    const { proxy } = getCurrentInstance();
    //导入图标
    library.add(faChevronRight, faChevronLeft)

    const props = defineProps(['materialList', 'titleText'])
    const emits = defineEmits(['clickMaterialBtn'])

    const changeNum = ref(0)
    let timerHandler = null

    // const titleText = computed(() => {
    //     let text = "產品促銷網"
    //     console.log(props)
    //     console.log(props["titleText"])
    //     if (null != props["titleText"]){
    //         text = props["titleText"]
    //     }
    //
    //     return text
    // })

    function throwAskEvent(obj) {
        emits("clickMaterialBtn", obj)
    }

    function previousMaterial(){
        if (changeNum.value > 0){
            changeNum.value = changeNum.value - 1
        }
    }

    function nextMaterial(){
        if (changeNum.value + 1 >= props.materialList.length - 4){
            changeNum.value = 0
        }else{
            changeNum.value = changeNum.value + 1
        }
    }

    onMounted(() => {
        timerHandler = setInterval(() => {
            if (null == props.materialList || props.materialList.length <= 4){
                return
            }else{
                if (changeNum.value + 1 > props.materialList.length - 4){
                    changeNum.value = 0
                }else{
                    changeNum.value = changeNum.value + 1
                }
            }
        }, 6500)

        // const dom = proxy.$refs.threeShopMaterialBox
    })

    onUnmounted(() => {
        clearInterval(timerHandler)
    })
</script>

<style scoped>
    @media screen and (min-width: 768px) {
        .card-product-box {
            /*width: 425px;*/
            width: 100%;
            height: 100%;
            position: relative;
            border: 0 solid;
            box-shadow: 5px 5px 10px #aaaaaa;
            background-color: #FFFFFF;
            margin: 0 auto;
            border-radius: 10px;
            padding: 5px;
            overflow: hidden;
            user-select: none;

        }
    }

    @media screen and (max-width: 768px) {
        .card-product-box {
            width: 100%;
            height: 100%;
            position: relative;
            border: 0 solid;
            box-shadow:5px 5px 10px #aaaaaa;
            background-color: #FFFFFF;
            margin:0 auto;
            border-radius: 10px;
            padding: 5px;
            overflow: hidden;
            user-select: none;


        }
    }

    .title-part {
        margin: 0 0 5px;
        padding: 5px 0;
        border-bottom: 1px solid #e5e5e5;
        position: relative;
        text-align: left;
        display: flex;
        justify-content: space-between;
    }

    .title-part:before {
        position: absolute;
        left: 0;
        height: 3px;
        bottom: -2px;
        content: "";
        background: #e83f33;
        width: 130px;
    }

    .title-span {
        font-size: 15px;
        font-weight: 600;
    }

    .material-part {
        flex-wrap: nowrap;
        align-items: center;
        overflow: hidden;
        /*margin-top: 25px;*/
        position: relative;
        height: 100%;
    }

    .material-inline-block {
        width: 25%;
        top: 0;
        position: absolute;
        transition: all 1.5s ease;
    }
</style>